module.exports = __webpack_public_path__ + "static/project-7e-b7305135e552b9ab82574d85684f87b9.png";